import Toolbar from "@mui/material/Toolbar";
import Head from "next/head";
import React, { Fragment } from "react";
import ToResolveClassNameError from "../../components/hoc/ToResolveClassNameError";
import SpecialisationsAndExperienceLevelsContent from "../../components/job-search/SpecialisationsAndExperienceLevelsContent/SpecialisationsAndExperienceLevelsContent";
import SharedFooter from "../../components/shared/SharedFooter/SharedFooter";
import SharedNavbar2 from "../../components/shared/SharedNavbar/Navbar/Navbar";
import * as config from "../../config/config";
import {
  getExperienceLevelsWithoutRedux,
  getSpecialisationWithoutRedux,
} from "../../redux/actions/job_action";

function JobsBySpecialisationAndExperienceLevel(props) {
  const { experiences = [], specialisations = [] } = props;
  const metaTitle =
    "Jobs by Specialisation and Experience Level - Hiredly - Find Jobs in Malaysia";
  const metaDescription =
    "Jobs by Specialisation and Experience Level - Hiredly. Find full time, internship and work from home jobs in Malaysia. Upload your resume and let our headhunters find a job vacancy for you.";

  return (
    <Fragment>
      <Head>
        {/* <!-- Primary Meta Tags --> */}
        <title>{metaTitle}</title>
        <meta name="title" content={metaTitle} />
        <meta name="description" content={metaDescription} />

        {/* <!-- Open Graph / Facebook --> */}
        <meta property="og:type" content="website" key={"ogType"} />
        <meta
          property="og:url"
          content="https://my.hiredly.com/sitemap/jobs-by-specialisation-and-experience-level"
          key="ogUrl"
        />
        <meta property="og:title" content={metaTitle} key="ogTitle" />
        <meta
          property="og:description"
          content={metaDescription}
          key="ogDescription"
        />
        <meta
          property="og:image"
          content={
            config.assetDomain + "/images/hiredly/hiredly-meta-image-v1.png"
          }
          key="ogImage"
        />

        {/* <!-- Twitter --> */}
        <meta
          property="twitter:card"
          content="summary_large_image"
          key="twitterCard"
        />
        <meta
          property="twitter:url"
          content="https://my.hiredly.com/sitemap/jobs-by-specialisation-and-experience-level"
          key="twitterUrl"
        />
        <meta property="twitter:title" content={metaTitle} key="twitterTitle" />
        <meta
          property="twitter:description"
          content={metaDescription}
          key="twitterDescription"
        />
        <meta
          property="twitter:image"
          content={
            config.assetDomain + "/images/hiredly/hiredly-meta-image-v1.png"
          }
          key="twitterImage"
        />
        <meta
          name="viewport"
          content="minimum-scale=1, initial-scale=1, width=device-width"
        />
        <link
          rel="canonical"
          href="https://my.hiredly.com/sitemap/jobs-by-specialisation-and-experience-level"
        />
      </Head>
      <ToResolveClassNameError>
        <SharedNavbar2 />
      </ToResolveClassNameError>

      <SpecialisationsAndExperienceLevelsContent
        experiences={experiences}
        specialisations={specialisations}
      />

      <Toolbar />

      <SharedFooter />
    </Fragment>
  );
}

export async function getStaticProps() {
  let specialisationList = [];
  let experienceList = [];

  try {
    const result = await getSpecialisationWithoutRedux();
    specialisationList = Array.isArray(result) ? result : [];
  } catch (err) {
    try {
      const fallbackResult = await getSpecialisationWithoutRedux();
      specialisationList = Array.isArray(fallbackResult) ? fallbackResult : [];
    } catch (fallbackErr) {
      specialisationList = [];
    }
  }

  try {
    const result = await getExperienceLevelsWithoutRedux();
    experienceList = Array.isArray(result) ? result : [];
  } catch (err) {
    try {
      const fallbackResult = await getExperienceLevelsWithoutRedux();
      experienceList = Array.isArray(fallbackResult) ? fallbackResult : [];
    } catch (fallbackErr) {
      experienceList = [];
    }
  }

  return {
    props: {
      specialisations: specialisationList,
      experiences: experienceList,
    },
    revalidate: 86400,
  };
}

export default JobsBySpecialisationAndExperienceLevel;
